<!--
Author: Eddy <eddy@alphapod.com>
Contributor: Add your name here if you edit this file
Module: Contact Us Form
Description:
This component represents the final "Thank You" page of the multi-step "Contact Us" form.
It displays a message thanking the user for their submission and informs them that someone from the team will respond shortly.
The message also includes a link to view some of the projects the company has done.

How to use it:
<ContactUsThankYou />
This component is displayed after the user completes all steps of the contact form. No props or events are required.
-->
<template>
  <div class="thank-you-container">
    <h2>
      Thank you.
    </h2>
    <p>Someone from our team will get back to you as soon as possible. Meanwhile, check out <a :href="`${sitePath}work/`">some of the projects we’ve done.</a></p>
  </div>
</template>

<script setup lang="ts">
import { onMounted, inject, computed, ref} from 'vue';
import axios from 'axios';

const wpData = inject('wordpressData');
const mainSite = computed(() => wpData?.value?.is_main_site ?? true);
const siteID = computed(() => wpData?.value?.blog_id ?? 1);
const sitePath = computed(() => wpData?.value?.multisite_path ?? '/');

</script>
<style scoped>
.thank-you-container {
  display: flex;
  width: 100%;
  height: 100vh;
  flex-direction: column;
  justify-items: center;
  justify-content: center;
  align-items: center;
}

.thank-you-container h2{
  color: #242424;
  text-align: center;
  font-family: 'Inter', sans-serif;
  font-size: 160px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: -8px;
  width: 1024px;
}

.thank-you-container p{
  color: #242424;
  text-align: center;
  font-family: 'Inter', sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 32px;
  max-width: 619px;
}

.thank-you-container a{
  color: #007AFF;
  font-family: 'Inter', sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 32px;
  text-decoration-line: underline;
}

@media screen and (max-width: 1024px) {

  .thank-you-container {
    height: 50vh;
  }
  .thank-you-container h2{
    color: var(--Neutrals-Nero, #242424);
    text-align: center;
    font-family: 'Inter', sans-serif;
    font-size: 64px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: -5px;
    width: auto;
    margin-bottom: 24px;
  }

  .thank-you-container p{
    color: var(--Neutrals-Nero, #242424);
    text-align: center;
    font-family: 'Inter', sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 150% */
    letter-spacing: -0.25px;
  }

  .thank-you-container a{
    color: var(--Primary-Dodger-Blue, #007AFF);
    font-family: 'Inter', sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: -0.25px;
    text-decoration-line: underline;
  }
}

</style>
